import { render, staticRenderFns } from "./AppNavbarHorizontalLayout.vue?vue&type=template&id=08fa3248&"
import script from "./AppNavbarHorizontalLayout.vue?vue&type=script&lang=js&"
export * from "./AppNavbarHorizontalLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports